
import { defineComponent, ref, SetupContext } from 'vue'
import NetworkPoints from '@/components/network-point/Points.vue'
import { Search } from 'vant'

export default defineComponent({
  name: 'Networkpoint-List',
  components: {
    NetworkPoints,
    VanSearch: Search,
  },
  emits: ['searchFocus', 'searchBlur'],
  setup(props, context) {
    const keywords = ref('')
    const isFocus = ref(false)
    const searchbox = ref<HTMLElement>()
    // let timer: any = null
    // const clearTimer = () => {
    //   if (timer) {
    //     clearTimeout(timer)
    //   }
    // }
    // watch(keywords, (newv) => {
    //   clearTimer()
    //   timer = setTimeout(() => {
    //     context.emit('changeKeywords', newv)
    //   }, 300)
    // })
    const onFocus = () => {
      isFocus.value = true
      context.emit('searchFocus')
    }
    const onBlur = () => {
      isFocus.value = false
      context.emit('searchBlur', keywords.value)
    }
    const onCancel = () => {
      searchbox.value.blur()
      context.emit('searchBlur', keywords.value)
    }
    return {
      searchbox,
      isFocus,
      onBlur,
      onFocus,
      keywords,
      onCancel,
    }
  },
})
